import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import IndexPage from 'flarum/forum/components/IndexPage';
import PagePagePC from './PagePagePC';
import PagePage from '../../common/models/PagePage';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import Button from 'flarum/components/Button';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from "flarum/common/utils/ItemList";
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import LinkButton from 'flarum/common/components/LinkButton';
import sortTags from 'flarum/tags/common/utils/sortTags';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Search from 'flarum/forum/components/Search';
import classList from 'flarum/common/utils/classList';
import Placeholder from 'flarum/common/components/Placeholder';

//主页
export default class SearchView extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--page';
    this.loading = true;
    this.query = this.attrs.q ? this.attrs.q : ''
    app.discussions.refreshParams(app.search.params(), (m.route.param('page') && Number(m.route.param('page'))) || 1);
    app.history.push(`${this.attrs.routeName}`);
  }

  title() {
    return <h4 className="App-titleControl search-title"><Search state={app.search} /></h4>;
  }

  view() {
    return (
      <main class="App-content">
        {this.title()}
        <div id="content">
          {this.query == '' ? <Placeholder text={app.translator.trans('dl-search.forum.notSearch')} /> :
          <div className="searchPage">
            <div className="extra-search-content">
              {listItems(this.contentItems().toArray())}
            </div>
            <div className="dl-content">
              <div>
                <div className="IndexPage-toolbar dl-discussion-container">
                  {this.content()}
                </div>
              </div>
            </div>
          </div>
        }
        </div>
      </main>
    );
  }

  content() {
      return <DiscussionList state={app.discussions} />
  }
  

  onremove(vnode) {
    super.onremove(vnode);
    app.search.clear();
  }

  contentItems() {
    const items = new ItemList();

    if (app.forum.attribute('canViewForum')) {
      items.add(
        'posts',
        <LinkButton
          className= {classList([
            'extra-myPosts-container',
            this.attrs.routeName == 'search' ? 'extra-click-change' : '',
          ])}
          href={app.route('search', { q: this.query })}
        >
        <span>{app.translator.trans('dl-search.forum.posts')}</span> 
        </LinkButton>
      );
    }
    
    if (app.forum.attribute('canSearchUsers')) {
      items.add(
        'users',
        <LinkButton
        className= {classList([
          'extra-myPosts-container',
          this.attrs.routeName == 'search.userSearch' ? 'extra-click-change' : '',
        ])}
          href={app.route('search.userSearch', { q: this.query })}
        >
        <span>{app.translator.trans('dl-search.forum.users')}</span> 
        </LinkButton>
      );
    }
    

    return items;
  }
}


